import {ColorInterpolation} from '../../classes/ColorInterpolation';

declare let THREE: any;

export class GridGround extends (THREE.Mesh as { new(geometry, material): any; }) {

  private groundMaterialColor: ColorInterpolation;

  constructor() {
    const groundMaterialColor = new ColorInterpolation(
      new THREE.Color(0.7, 0.7, 0.7),
      new THREE.Color(.1, .1, .1)
    );
    const material = new THREE.MeshPhongMaterial({color: groundMaterialColor.getStart()});
    const geometry = new THREE.PlaneBufferGeometry(40000, 40000);
    super(geometry, material);
    material.needsUpdate = true;
    this.rotation.x = -Math.PI / 2;
    this.receiveShadow = true;
    this.position.y = -1;
    this.name = 'ground';
    this.groundMaterialColor = groundMaterialColor;
  }

  interpolateColor(input: number) {
    this.material.color.copy(
      this.groundMaterialColor.interpolate(input)
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/custom/env/GridGround.ts